import { render, staticRenderFns } from "./FormReleasesPg.vue?vue&type=template&id=561fd3d8&scoped=true&"
import script from "./FormReleasesPg.vue?vue&type=script&lang=js&"
export * from "./FormReleasesPg.vue?vue&type=script&lang=js&"
import style0 from "./FormReleasesPg.vue?vue&type=style&index=0&id=561fd3d8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "561fd3d8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VFileInput } from 'vuetify/lib/components/VFileInput';
import { VForm } from 'vuetify/lib/components/VForm';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCol,VFileInput,VForm,VRow,VTextField})
